import React, { Fragment, useEffect, useState } from 'react';
import { Loading } from '@/components';
import { States } from '@/helpers/common/states';
import api, { AxiosError } from '@/services/api';
import { EventPosFilterReport } from '@/model/EventPosFilterReport';
import { EventPosReport } from '@/model/EventPosReport';
import { toast } from 'react-toastify';
import useForm from '@/hooks/useForm';
import { SalePosContent } from './ui';
import { ReportControllerProps } from '../../types';
import { FormInputFilter } from './types';

interface SalePosProps {
  reportController: ReportControllerProps;
  generatePDF: () => void;
}

export const SalePos: React.FC<SalePosProps> = ({ reportController, generatePDF }): JSX.Element => {
  const [state, setState] = useState<States>(States.default);
  const [eventPosReport, setEventPosReport] = useState<EventPosReport>();

  const handleGetPosSales = async (filter: EventPosFilterReport): Promise<void> => {
    try {
      setState(States.loading);
      const { data } = await api.post<EventPosReport>(
        `event/report/${reportController.eventId}/sale-pos?singleEvent=${reportController.singleEvent}`,
        filter,
      );
      if (data) {
        setEventPosReport(data);
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    } finally {
      setState(States.default);
    }
  };

  const { formData, formErrors, onChangeFormInput, isFormValid, resetForm } = useForm({
    initialData: {
      date: '',
      serialNumber: '',
    },
  });

  const handleOnFilter = async (): Promise<void> => {
    if (isFormValid()) {
      const filter: EventPosFilterReport = {};
      if (formData[FormInputFilter.date]) {
        filter.date = formData[FormInputFilter.date];
      }
      if (formData[FormInputFilter.serialNumber]) {
        filter.serialNumber = formData[FormInputFilter.serialNumber];
      }
      handleGetPosSales(filter);
    }
  };

  const handleOnClearFilter = async (): Promise<void> => {
    resetForm();
    handleGetPosSales({});
  };

  useEffect(() => {
    handleGetPosSales({});
  }, []);
  return (
    <Fragment>
      <Loading isVisible={state === States.loading} />
      <SalePosContent
        eventPosReport={eventPosReport}
        formData={formData}
        formErrors={formErrors}
        onChangeFormInput={onChangeFormInput}
        onFilter={handleOnFilter}
        onClearFilter={handleOnClearFilter}
        generatePDF={generatePDF}
      />
    </Fragment>
  );
};
